const SECRET_PATTERNS = [
  /Bearer\s+[A-Za-z0-9._\-+/=]+/gi,
  /api[_-]?key[=:\s]+[A-Za-z0-9._\-+/=]+/gi,
  /re_[A-Za-z0-9]+/g,
  /sk-[A-Za-z0-9]+/g,
  /[A-Za-z0-9+/]{40,}={0,2}/g,
  /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g,
];

const SENSITIVE_KEY_PATTERN =
  /password|passwd|token|secret|authorization|cookie|ssn|social.?security|card.?number|apikey|api[_-]?key|credit.?card|phone|email/i;

function isSensitiveKey(key: string): boolean {
  return SENSITIVE_KEY_PATTERN.test(key);
}

export function redactLogValue(value: unknown, key?: string): unknown {
  if (key && isSensitiveKey(key)) return '[REDACTED]';

  if (typeof value === 'string') {
    let result = value;
    for (const pattern of SECRET_PATTERNS) {
      result = result.replace(pattern, '[REDACTED]');
    }
    return result;
  }

  if (Array.isArray(value)) return value.map((v) => redactLogValue(v));
  if (value && typeof value === 'object') {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(value)) {
      out[k] = redactLogValue(v, k);
    }
    return out;
  }

  return value;
}
